/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        /****************
        **  Mobile dropdown menus
        *****************/
        $('#mobile-nav-primary').on('show.bs.collapse', function () {
          $('header.banner').addClass('nav-open');
        })
        $('#mobile-nav-primary').on('hidden.bs.collapse', function () {
          $('header.banner').removeClass('nav-open');
        })


        /****************
        **  Carousels
        *****************/
        $('.testimonials-carousel').each(function() {
          $(this).slick({
            rows: 0,
            dots: true,
            infinite: true,
            speed: 400,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 8000,
            prevArrow: $(this).find(".prev-testimonial"),
            nextArrow: $(this).find(".next-testimonial"),
          });
        });
        $(".testimonials-carousel div.slick-slide").matchHeight();

        /****************
        **  Gallery lightbox
        *****************/
        $('.gallery-grid').slickLightbox({
          caption: 'caption',
          useHistoryApi: 'true'
        });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // BLOG
    'blog': {
      init: function() {

        /****************
        **  Category Jump Menu
        *****************/
        $('select[name="category"]').on('change', function () {
          var url = $(this).val();
          if (url) { window.location = url; }
          return false;
        });


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // ARCHIVE
    'archive': {
      init: function() {

        /****************
        **  Category Jump Menu
        *****************/
        $('select[name="category"]').on('change', function () {
          var url = $(this).val();
          if (url) { window.location = url; }
          return false;
        });


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
